module.exports = __webpack_public_path__ + "img/item-9.37b61be6.png";